import React, { useState, useEffect, useRef } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Empty, Select, Pagination, Tooltip, Input } from "antd";

import RTableSelectable from "../RTableSelectable";
import InterviewTableSelectable from "../InterviewTableSelectable";
import CandidateAddModal from "../CandidateAddModal";
import CommTableSelectable from "../CommTableSelectable";
import TextFilter from "../textFilter";
import LexicalSort from "../lexicalSort";
import NumericFilter from "../numericFilter";
import useCandidateStore from "../../store/candidateModal.store";
import useMembersStore from "../../store/members.store";
import "./jdSummary.scss";
import cloudIcon from "../../assets/upload.png";
import PieChart from "../PieChart";
import useResumeStore from "../../store/resume.store";
import useStatsStore from "../../store/stats.store";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  LeftOutlined,
  RightOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import {
  candidateStatusFilter,
  bgvStatusFilter,
  parsingErrorFilter,
  resumeSuitabilityFilter,
  resumeStatusFilter,
  interviewStatusFilter,
  offerStatusFilter,
  reasonForNotWorkingFilter,
  documentStatusFilter,
  educationAnalysisFilter,
  experienceAnalysisFilter,
  genderFilter,
  reasonForLeavingFilter,
  otherOffersFilter,
  payrollFilter,
  skillMatrixSuitabilityFilter,
  assessmentSuitabilityFilter,
  interviewTypeFilter,
  ownershipFilter,
} from "../../helper/filterconstants";
import { FILTER_DURATION_OPTIONS, VIEW_FILTER_CONFIG } from "../../helper/categoryconstants";
import Table from "../Table";
import { GetOwnership, GetSourceOwner } from "../../helper/commonFunctions";

const { Search } = Input;

const summaryListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name", 
    'Email', 
    "Mobile",
    "Updated On",     
    "Resume Suitability",           
    "Preferred Location",
    "Total Exp",
    "Current CTC",
    "ECTC",
    "Notice Period", 
    "LWD",           
    "Updated By",
];

const personalListTable = [
    "Sr. No.",
    "Resume ID",
    "Name",
    "Email Id",
    "Mobile",
    "Aadhar ID",
    "Gender",
    "Current Location",
    "Preferred Location",
    "Designation",
    "Company",
    "Max Degree",
    "Stream",
    "Passing Year",
    "Candidate Status",
];

const matchingLinkResponseTable = [
  "Sr. No.",
  "Added",
  "Duplicate",
];


const summaryStatusListTable = [
  "Select",
  "Sr. No.",
  "Resume ID",
  "Name",
  "Mobile",
  "Email Id",
  "Resume Suitability",
  "Candidate Status",
  "Resume Status",
  "Interview Type",
  "Interview Status",
  "Selection Status",
  "Offer Status",
];

const ctcListTable = [
    "Sr. No.",
    "Resume ID",
    "Name",
    "Current CTC",
    "ECTC",
    "CTC Remarks",
    "Official NP",
    "Negotiable NP",
    "LWD",
    "Reason for Leaving",
    "Currently Employed",
    "Reason for Not Working",
    "Other Offers",
    "Other Joining Date",
    "Offer CTC",
    "Offer Company Type",
    "Candidate Status",
];

const suitablityListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Payroll",
    "Total Exp",
    "Relevant Exp",       
    "Skill Tags",
    "Soft Skills",
    "Resume Suitability",  
    "Skill Matrix Suitability",
    "Assessment Suitablity",
    "Resume Status",  
    "Comments",
    "Updated By",
    "Updated On",
    "Candidate Status",
];
const suitablityListTableInternal = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Job Type (P/TP)",
    "Total Exp",
    "Relevant Exp",       
    "Skill Tags",
    "Soft Skills",
    "Resume Suitability",  
    "Skill Matrix Suitability",
    "Assessment Suitablity",
    "Resume Status",  
    "Comments",
    "Updated By",
    "Updated On",
    "Candidate Status",
];

const sourcingListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",
    "Name", 
    "Email Id",
    "Mobile",
    "Ownership",
    "Name",
    "User ID",
    "Uploading Date",    
    "Source",
];

const interviewListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Mobile",       
    "Interview Type",
    "Interview Date",
    "Interview Time",
    "Interview Status",
    "Remarks",
    "No of Reschedules",
    "Resume Status",
    "Updated By",
    "Updated On",
    "Interview History"
];

const selectionListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Interview Status",
    "Offer Status", //offered/declined/joinedelesewhere/hold/joined/accepted
    "Docu status",//pending, submitted,issues
    "BGV Status", //oongoing,bgv ok, bgv fail
    "Expected DoJ",
    "ECTC",
    "Offered CTC",
    "Remarks",
    "Updated By",
    "Updated On"
];

const communicationListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name",  
    "Email",
    "Phone",
    "Candidate Status",         
    "Resume Status",
    "Candidate Interest Mails",
    "Slot Mails",
    "Interview Reminder Mails",
    "Feedback Reminder Mails"
];
const resumeAnalysisListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",
    "Name", 
    "Email",
    "Mobile",
    "Resume Suitability",
    "Final Analysis",      
    "Skill Analysis",
    "Role Analysis",
    "Education Analysis",
    "Exp Analysis",
    "Mentioned Exp (Y)",   
    "Cumulative Exp (Y)",
    "Expected Exp (Y)", 
    "Grammer",
    "Parsing Errors",
    //"Algorithm Time (s)",
    "Missing Skills"
];

const resumeViewMap = {
  summary: "Summary",
  resume_analysis_table: "Resume Analysis Table",
  personal: "Personal",
  ctc: "CTC and NP",
  skills: "Resume Status",
  interview: "Interviews",
  selections: "Selections and Offers",
  automated_sourcing: "Automated Sourcing",
  communications: "Communications",
  sourcing: "Sourcing",
};

export default function JDMatchingAutomation() {
  const [currentView, setCurrentView] = useState("summary");
  const [currentFiltersToView, setCurrentFiltersToView] = useState([]);
  const [currentViewFilters, setCurrentViewFilters] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedResumeID, setResumeID] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { value } = useParams();
  const { teamMembers } = useMembersStore();
  const scrollRef = useRef(null);
  const updatedByList =
    teamMembers?.map((member) => ({
      value: member?.username,
      label: member?.username,
    })) || [];
  useEffect(() => {
    if (!window.location.href.includes("candidateProfile")) {
      setCurrentView("summary");
    }
  }, [window.location.href]);

  useEffect(() => {
    if (currentFiltersToView.length == 0) {
      setSearchInput("");
    }
  }, [currentFiltersToView]);



  const [filterApiParameters, setFilterApiParameters] = useState({
    search: "",
    sortBy: "",
    sortOrder: "",
    "Total Experience": "All",
    "Relevant Experience": "All",
    "Current CTC": "All",
    ECTC: "All",
    "Notice Period": "All",
    "Candidate Status": [],
    "Resume Suitability": [],
    "Resume Status": [],
    "Education Analysis": [],
    "Experience Analysis": [],
    "Parsing Errors": [],
    Gender: [],
    "Reason For Leaving": [],
    "Reason For Not Working": [],
    "Other Offers": [],
    Payroll: [],
    "Skill Matrix Suitability": [],
    "Assessment Suitability": [],
    "Interview Status": [],
    "Interview Type": [],
    "Offer Status": [],
    Ownership: [],
    "Source By": [],
    "Updated By": [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [importRefreshFlag, setImportRefreshFlag] = useState(false);
  const [durationChange, setDurationChange] = useState(false);
  const {
    resumes,
    resetSelectedProfileResume,
    resetSelectedApplication,
    selectedJDMapData,
  } = useResumeStore();
  const { autoResumeMatchingStats, getAutoResumeMatching,totalResumesAutoMatching,autoResumeMatchingLinkRefresh,
          resetAutoResumeMatchingLinkRefresh,linkedAutoResumeMatchingStats } = useStatsStore();

  const handlePageChange = (page, pageSize) => {
    console.log("Page:", page, "PageSize:", pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const setFilterParameters = (newFilters) => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));

  };
  const [previousFilterState, setPreviousFilterState] = useState(null);

  const pullAvailableData = () => {
    // Store current filter state before changing to Available
    console.log("Storing previous filter state in pull:", filterApiParameters);
    
    // Store the current state before updating
    const currentState = { ...filterApiParameters };
    setPreviousFilterState(currentState);
    
    setFilterApiParameters(prevFilters => ({
      ...prevFilters,
    }));
  };

  const restorePreviousData = () => {
    console.log("Restoring previous filter state:", previousFilterState);
    
   
      // If no previous state, just remove "Available" from current filters
      setFilterApiParameters(prevFilters => ({
        ...prevFilters,
        "Candidate Status": prevFilters["Candidate Status"].filter(status => status !== "Available")
      }));
    setPreviousFilterState(null); // Clear stored state after restoring
    
  };

  useEffect(() => {  
    getAutoResumeMatching(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("sourcing.duration")); 
  }, [filterApiParameters, currentPage, pageSize, importRefreshFlag]);

  useEffect(() => {  
   if(autoResumeMatchingLinkRefresh){
      getAutoResumeMatching(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("sourcing.duration")); 
      resetAutoResumeMatchingLinkRefresh();
    }
  }, [autoResumeMatchingLinkRefresh]);  
  useEffect(() => {

  }, []);

    useEffect(() => {
        if(durationChange){
            //getResumesByJD(value);
            console.log("Fetching all applications due to update flag");
            getAutoResumeMatching(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("sourcing.duration"));           

            setDurationChange(false)
        }
    }, [durationChange]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkScroll = () => {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    checkScroll();
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  useEffect(() => {
    if (
      !location.pathname.includes("/candidateProfile/") &&
      currentView === "profile"
    ) {
      setCurrentView("summary");
    }
  }, [location.pathname]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    const scrollAmount = 95;
    if (direction === "left") el.scrollLeft -= scrollAmount;
    else el.scrollLeft += scrollAmount;
  };

   const GetNoticePeriod = (qhrid)=>{
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return ({
                officialnp: resumes[idx]?.employmentdetails.noticeperiod.officialnp,
                lwd: resumes[idx]?.employmentdetails.noticeperiod.lwd
        }) 
       }
     }
   }

   function GetResumeDetails(qhrid){
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return (
                 resumes[idx]
        ) 
       }
     }
   }
   const GetLastUpdated = (appDetail)=>{
        if(appDetail.resumestatus?.updatedby.timestamp === 0 ){
            return ({
                updatedBy: appDetail.candidatestatus?.updatedby.name,
                updatedOn: appDetail.candidatestatus?.updatedby.updatedon
        })
        }
        else if (appDetail.candidatestatus?.updatedby.timestamp > appDetail.resumestatus?.updatedby.timestamp) {  
            return ({
                updatedBy: appDetail.candidatestatus?.updatedby.name,
                updatedOn: appDetail.candidatestatus?.updatedby.updatedon
        }) 
       }else{
        return ({
            updatedBy: appDetail.resumestatus?.updatedby.name,
            updatedOn: appDetail.resumestatus?.updatedby.updatedon
        })
       }
   }

   const GetLastUpdatedSelections = (appDetail)=>{

    //find which one is latest timestamp
    if((appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )
        && (appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.selectionstatus?.updatedby.name,
            updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }
    else if((appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.bgvstatus?.updatedby.name,
            updatedOn: appDetail?.bgvstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }else if((appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.documentsstatus?.updatedby.name,
            updatedOn: appDetail?.documentsstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    } else{
    return ({
        updatedBy: appDetail?.selectionstatus?.updatedby.name,
        updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
        remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
   }
}

    const GetPreferredLocation = (appDetail)=>{
        var loc =""
        for(let idx = 0; idx < appDetail?.newemploymentdetails?.preferredlocation?.length; idx++){
            if(idx >0){
                loc = loc + ","
            }  
            loc = loc + appDetail?.newemploymentdetails?.preferredlocation?.[idx]
            return loc
         }
         return loc
        } 

    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   
    
    const summaryDataNew = autoResumeMatchingStats?.map((appInfo, idx) => {
  
        var resumeDetail = appInfo.resume
        var appDetail = appInfo.app
        let nPeriod = GetNoticePeriod(appDetail?.qhrid) 
        let lUpdate = GetLastUpdated(appDetail)         
        //console.log("Summary New Data current page",currentPage,pageSize)
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name, 
            email: appDetail?.applicationid.email,
            mobile: appDetail?.applicationid.mobile, 
            dateAdded: resumeDetail?.timestamp>0?formatUnixDate(resumeDetail?.timestamp):"--",               
            //currentLocation: resumeDetail?.employmentdetails?.currentlocation,              
            resumeSuitability:appDetail?.resumescore?.scorestr,           
            //candidateStatus: appDetail?.candidatestatus?.status, 
            preferredLocation: appDetail?.newemploymentdetails?.preferredlocation?.join(", ") || "--", 
            totalexp: appDetail?.resumescore.expparsed,
            cCTC: resumeDetail?.employmentdetails.currentctc?.totalctc,
            ECTC: appDetail?.newemploymentdetails.ectc.totalctc,
            noticePeriod: nPeriod?.officialnp == 1024?"":nPeriod?.officialnp, 
            lwd: nPeriod?.officialnp == 1024?"":nPeriod?.lwd, 
            //resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,           
            //remarks: appDetail?.newemploymentdetails?.otherremarks,
            uploadedBy: resumeDetail?.updatedby,         
    };
  });

  const summaryStatusData = autoResumeMatchingStats?.map((appInfo, idx) => {
    
    var resumeDetail = appInfo.resume
    var appDetail = appInfo.app
    return {
      select:"",
      id: idx+1+ (currentPage-1)*pageSize,
      qhid: appDetail?.resumeData?.qhrid,
      name: appDetail?.resumeData?.personaldetail.name,
      mobile: appDetail?.resumeData?.personaldetail.mobile,
      email: appDetail?.resumeData?.personaldetail.email,

      resumeSuitability:
        appDetail?.resumescore?.scorestr,
      candidateStatus: appDetail?.candidatestatus?.status,
      resumeStatus: appDetail?.resumestatus?.status,
      interviewType: appDetail?.interviewstatus?.type,
      interviewStatus: appDetail?.interviewstatus?.status,
      selectionStatus: appDetail?.selectionstatus?.status,
      offerStatus: appDetail?.offerstatus?.status,
    };
  });

  const personalDetailsData = autoResumeMatchingStats?.map((appInfo, idx) => {
    
    var resumeDetail = appInfo.resume
    var appDetail = appInfo.app
    var pLoc = GetPreferredLocation(appDetail);

        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:resumeDetail?.qhrid,
            name: resumeDetail?.personaldetail.name,
            email: resumeDetail?.personaldetail.email,
            phone: resumeDetail?.personaldetail.mobile,
            aadhar: resumeDetail?.personaldetail.aadharid,
            gender: resumeDetail?.personaldetail.gender,
            currentLocation: resumeDetail?.employmentdetails?.currentlocation, 
            preferredLocation: appDetail?.newemploymentdetails?.preferredlocation !=null ? appDetail?.newemploymentdetails?.preferredlocation:"--",          
            currentDesignation: resumeDetail?.employmentdetails.designation,
            currentCompany: resumeDetail?.employmentdetails?.currentcompany,
            maxDegree: resumeDetail?.educationaldetail.maxdegree,
            stream: resumeDetail?.educationaldetail.stream, 
            passoutyear: resumeDetail?.educationaldetail.passoutyear,   
            candidateStatus: appDetail?.candidatestatus?.status,         
        };
    });    

    const ctcDetailsData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var resumeDetail = appInfo.resume
        var appDetail = appInfo.app
        return {
            id:idx+1+ (currentPage-1)*pageSize,
            qhid:resumeDetail?.qhrid,
            name: resumeDetail?.personaldetail.name,
            cCTC: resumeDetail?.employmentdetails.currentctc?.totalctc,
            eCTC: appDetail?.newemploymentdetails?.ectc?.totalctc,
            remarksCTC: appDetail?.newemploymentdetails?.ectc?.ctcremarks,
            noticePeriodOfficial: resumeDetail?.employmentdetails?.noticeperiod?.officialnp==1024?"":resumeDetail?.employmentdetails.noticeperiod.officialnp,
            noticePeriodNegotiable: resumeDetail?.employmentdetails?.noticeperiod?.negotiableto==1024?"":resumeDetail?.employmentdetails.noticeperiod.negotiableto,            
            LWD: resumeDetail?.employmentdetails.noticeperiod.lwd,
            reasonLeaving: resumeDetail?.employmentdetails.noticeperiod.reason,
            currentlyWorking: "",
            reasonNotWorkding:"",
            oOffer: resumeDetail?.offerdetails.otheroffer,
            oDOJ: resumeDetail?.offerdetails.offerdoj,
            oCTC: resumeDetail?.offerdetails.offerctc,
            oCompany: resumeDetail?.offerdetails.companytype,  
            candidateStatus: appDetail?.candidatestatus?.status,           
        };
    });   

    
    const suitabilityData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var resumeDetail = appInfo.resume
        var appDetail = appInfo.app      
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,                    
            payroll: appDetail?.newemploymentdetails.payroll,
            totalExp:appDetail?.newemploymentdetails.totalexp,
            relExp:appDetail?.newemploymentdetails.relevantexp,
            skills: appDetail?.resumestatus?.tags,  
            softskills: appDetail?.newemploymentdetails?.softskills,
            resumeSuitability: appDetail?.resumescore?.scorestr,
            skillMatix: appDetail?.skillmatix,
            assesment: appDetail?.assesment,
            resumeStatus: appDetail?.resumestatus?.status,
            resumeComments: appDetail?.resumestatus?.updatedby.remarks,
            updatedBy: appDetail?.resumestatus?.updatedby.name,
            updateOn: appDetail?.resumestatus?.updatedby.updatedon,
            candidateStatus: appDetail?.candidatestatus?.status, 
        };
    });

    const interviewData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var resumeDetail = appInfo.resume
        var appDetail = appInfo.app        
        return {
            select:"",
            id: idx+1,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            phone: appDetail?.applicationid.mobile, 
            iType: appDetail?.interviewstatus?.type?appDetail?.interviewstatus?.type:"--",
            iDate: appDetail?.interviewstatus?.interviewdate?appDetail?.interviewstatus?.interviewdate:"--",
            iTime: appDetail?.interviewstatus?.interviewtime?appDetail?.interviewstatus?.interviewtime:"--",
            iStatus: appDetail?.interviewstatus?.status?appDetail?.interviewstatus?.status:"--",
            interviewComments:appDetail?.interviewstatus?.updatedby.remarks,
            numResch: appDetail?.interviewstatus?.numrescheduled?appDetail?.interviewstatus?.numrescheduled:"--",
            candidateStatus: appDetail?.candidatestatus?.status,
            updatedBy: appDetail?.interviewstatus?.updatedby.name,
            updateOn: appDetail?.interviewstatus?.updatedby.updatedon,
            history:"Click Here"
        };
    });  


    const selectionData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var resumeDetail = appInfo.resume
        var appDetail = appInfo.app 
        let lUpdate = GetLastUpdatedSelections(appDetail)                   
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            interviewStatus: appDetail?.interviewstatus?.status?appDetail?.interviewstatus?.status:"--",
            sStatus: appDetail?.selectionstatus?.status?appDetail?.selectionstatus?.status:"--",
            dStatus: appDetail?.documentsstatus?.status?appDetail?.documentsstatus?.status:"--",
            bgvStatus: appDetail?.bgvstatus?.status?appDetail?.bgvstatus?.status:"--",
            eDoJ: appDetail?.newemploymentdetails?.finaldoj,
            eCTC: appDetail?.newemploymentdetails?.ectc?.totalctc,
            oCTC: appDetail?.newemploymentdetails?.octc?.totalctc,
            selectComments:lUpdate?.remarks,
            uploadedBy: lUpdate?.updatedBy,
            dateAdded: lUpdate?.updatedOn,
        };
    });    


    const colorData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var appDetail = appInfo.app  
        var method =appDetail?.sourcingdetails?.method
        return {
            select:"",
            id: idx+1,
            qhid:  appDetail?.qhrid,
            color: method === "By Team" ? "#d5e9fe" : 
                   method === "By Vendor" ? "#ff69b4" : method === "Through Career Page" ? "#1890ff" : 
                   method== "By Automation"? "#e3f6d7":"#f6f3ce"
        };
    });

    const sourcingData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var thisresume = appInfo.resume
        var appDetail = appInfo.app          
        var sOwner = GetSourceOwner(appDetail)
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            email: appDetail?.applicationid.email, 
            phone: appDetail?.applicationid.mobile,            
            method: appDetail?.sourcingdetails?.method=="By Team"?"Internal":appDetail?.sourcingdetails?.method,
            sName:sOwner.sourceName,
            sID:sOwner.sourceID,
            dateAdded: sOwner.sourceDate,            
            sourceMedium: thisresume?.firstuploadedby?.resumesource,
        };
    });

    
    const resumeAnalysisData = autoResumeMatchingStats?.map((appInfo, idx) => {
        var thisresume = appInfo.resume
        var appDetail = appInfo.app       
        const scorelist = appDetail?.resumescore?.scorelist || {};
        const keywordsObj = scorelist?.skill_scores?.keywords || {};
        const keywordString = Object.entries(keywordsObj)
          .filter(([_, value]) => (value.avg ?? 0) === 0)
          .map(([key]) => key)
          .join(", ");      
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,  
            email: appDetail?.applicationid.email,          
            mobile: appDetail?.applicationid.mobile, 
            resumeSuitabilityScore: appDetail?.resumescore?.score + " %",
            resumeSuitability: appDetail?.resumescore?.scorestr,             
            skillAna: appDetail?.resumescore.scorelist.skill_scores.score + " %",
            roleAna:appDetail?.resumescore.scorelist.role_scores.score  + " %",
            eduAna:appDetail?.resumescore.eduverdict?.verdict,
            expAna:appDetail?.resumescore.expverdict?.verdict,
            menExp: appDetail?.resumescore.expparsed,  
            cumExp: appDetail?.resumescore.cumulativeexp?.[0]?.c_yrs_months,          
            totalExp: appDetail?.resumescore.cumulativeexp?.[0]?.e_yrs_months,
            grammer: "--",          
            eduError: appDetail?.resumescore?.eduerrortype,
            matchingSkills: keywordString 
        };
    });
    const matchingLinkResponseDataCallback= (data) =>{
      const groupedResumes = {
        ok: [],
        duplicate: []
      };

      Object.entries(data)?.forEach(([resumeId, status]) => {
        if(status == "OK"){
          groupedResumes["ok"].push(resumeId);
        }else{
          groupedResumes["duplicate"].push(resumeId);
        }
        
      });

      // Convert to comma separated string
      const result = {
        ok: groupedResumes.ok.join(",") !== "" ?groupedResumes.ok.join(","):"None Linked",
        duplicate: groupedResumes.duplicate.join(",")!==""?groupedResumes.duplicate.join(",")!=="":"No Duplicates"
      };

      return result
    }
    const matchingLinkResponseData= [{
          id: 1,
          added: linkedAutoResumeMatchingStats?.ok,
          duplicate: linkedAutoResumeMatchingStats?.duplicate,
        }];

    const handleResumeProfile= (jdId,id,rid) => {
        resetSelectedProfileResume (value,rid)
        resetSelectedApplication (value,rid)
        setResumeID(rid)
    };


    const handleCurrentViewProfile = () =>{
        setCurrentView("profile")
    }

    const handleDuration =(dur)=>{
        console.log("Current sourcing duration", dur)
        localStorage.setItem("sourcing.duration", dur);
        setDurationChange(true)
      }
    const getDurationlabel =()=>{     
         var dur = localStorage.getItem("sourcing.duration")
         if(dur =="All"){
           return 'All Resumes'
         }else {
           var durInt = parseInt(dur, 10)
           if( durInt < 48){
              return 'Updated in Last '+ dur + ' hrs'
           }else
            return 'Updated in Last '+ dur/24 + ' days'
         }
      }

  const chartInfo = () => {
    return (
      <>
        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "5px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Avaible
          </div>
          <div className="chart-section-item">
            {" "}
            <span>A</span> - Available
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AHCTC</span> - Available HCTC
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AHNP</span> - Available HNP
          </div>
          <div className="chart-section-item">
            {" "}
            <span>DP</span> - Duplicate Profile
          </div>
        </div>
        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Need to Call
          </div>
          <div className="chart-section-item">
            {" "}
            <span>S</span> - Sourced
          </div>
          <div className="chart-section-item">
            {" "}
            <span>TBC</span> - To be Called
          </div>
          <div className="chart-section-item">
            {" "}
            <span>CL</span> - Call Later
          </div>
          <div className="chart-section-item">
            {" "}
            <span>JD</span> - JD Needed
          </div>
          <div className="chart-section-item">
            {" "}
            <span>NP</span> - Not Picking
          </div>
          <div className="chart-section-item">
            {" "}
            <span>B/D</span> - Busy/Disconnected
          </div>
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Suitability
          </div>
          <div className="chart-section-item">
            {" "}
            <span>NS</span> - Not Suitable
          </div>
          <div className="chart-section-item">
            {" "}
            <span>BA</span> - Below Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>A</span> - Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AA</span> - Above Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>GM</span> - Good Match
          </div>
          <div className="chart-section-item">
            {" "}
            <span>PS</span> - Partial Suitable
          </div>            
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Resume Status
          </div>
          <div className="chart-section-item">
            {" "}
            <span>S</span> - Shared
          </div>
          <div className="chart-section-item">
            {" "}
            <span>IRP</span> - Interview Planned
          </div>
          <div className="chart-section-item">
            {" "}
            <span>TBS</span> - To Be Scheduled
          </div>
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Resume Feedbacks
          </div>
          <div className="chart-section-item">
            {" "}
            <span>FBP</span> - Feedback Pending
          </div>
          <div className="chart-section-item">
            {" "}
            <span>CFBP</span> - Client Feedback Pending
          </div>
          <div className="chart-section-item">
            {" "}
            <span>SR</span> - Screen Reject
          </div>
          <div className="chart-section-item">
            {" "}
            <span>D</span> - Duplicate
          </div>
          <div className="chart-section-item">
            {" "}
            <span>IR</span> - Interview Reject
          </div>
          <div className="chart-section-item">
            {" "}
            <span>SS</span> - Screen Select
          </div>
        </div>
      </>
    );
  };

  const handleSearch = () => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      search: searchInput,
    }));
  };

  const updateViewFilterConfig =()=>{
      let finalConfig = VIEW_FILTER_CONFIG;
      const injectOptions = (config, key, options) =>
        config.map((item) =>
          item.key === key
            ? { ...item, options }
            : item
        );      
      finalConfig = injectOptions(finalConfig, "Updated By", updatedByList)
      finalConfig = injectOptions(finalConfig,"Source By",updatedByList);
      finalConfig = injectOptions(finalConfig,"Candidate Status Updated By",updatedByList);
      return finalConfig  
  }  
  return (
    <div className="jd-summary-wrapper">
      {currentView !== "profile" && (
        <>
            <div className="section-header">
                   <h3 className="title">Matching Resumes {" (" + totalResumesAutoMatching+ ") "} </h3>
	            <div className="section-header-input">
	              <Search
	                placeholder="Search by Name/Mobile/Email/Resume ID"
	                size="small"
	                value={searchInput}
	                onChange={(e) => setSearchInput(e.target.value)}
	                onSearch={handleSearch}
	                style={{ width: 350, height: 24, marginRight: 12 }}
	              />
                    <Select
                        style={{ width: 230,height: 24 }}
                        onChange={handleDuration}
                        showSearch={true}
                        filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}                  
                        placeholder={getDurationlabel()}                                                  
                        options={FILTER_DURATION_OPTIONS} 
                    /> 
                   </div>

          </div>
          <div className="jd-summary-buttons-wrapper-container">
            {canScrollLeft && (
              <div
                className="jd-summary-arrow-btn"
                onClick={() => scroll("left")}
              >
                <LeftOutlined />
              </div>
            )}
            <div className="jd-summary-buttons-wrapper" ref={scrollRef}>  
                <Button
                    className={`jd-summary-btn ${
                        currentView === "summary" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("summary")}
                >
                    Summary
                </Button>                          
                <Button
                  className={`jd-summary-btn ${
                    currentView === "resume_analysis_table" &&
                    "jd-summary-btn-active"
                  }`}
                  onClick={() => setCurrentView("resume_analysis_table")}
                >
                  Matching Resume Analysis Table
                </Button>
                <Button
                    className={`jd-summary-btn ${
                        currentView === "sourcing" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("sourcing")}
                >
                    Sourcing
                </Button>                
            </div>{" "}
            {canScrollRight && (
              <div
                className="jd-summary-arrow-btn"
                onClick={() => scroll("right")}
              >
                <RightOutlined />
              </div>
            )}
          </div>
          <div className="resumes-info-wrapper">
            <div className="resumes-chart" style={{marginTop : "30px"}}>
              {currentView !== "charts" && (
                <>
                      <Table
                        titleList={matchingLinkResponseTable}
                        data={matchingLinkResponseData}
                        columnWidth={[
                          50, 300, 300
                        ]}
                        dontShowFreezeComunButton = {true}
                      />
                </>
              )}
            </div>
            <div className="global-filter">
              <TextFilter
                currentView={resumeViewMap[currentView]}
                setCurrentPage={setCurrentPage}
                config={updateViewFilterConfig()}
                globalFilterData={filterApiParameters}
                setGlobalFilterData={setFilterApiParameters}
                lexicalsort={<LexicalSort                 
                               globalFilterData={filterApiParameters}
                               setGlobalFilterData={setFilterApiParameters}/>}   
              />
            </div>
          </div>
        </>
      )}
      {autoResumeMatchingStats ? (
        <div className="jd-summary-container">
          {currentView === "charts" ? (
            <>
              <div className="chart-summary">
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Available"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Need to Call"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Suitability"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Resume Status"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Resume Feedbacks"}
                />
                <div
                  id="fixed-tooltip-container"
                  className="chart-info"
                  style={{ position: "fixed", top: 0, left: 0, zIndex: 9999 }}
                ></div>

                <Tooltip
                  title={chartInfo()}
                  color="white"
                  overlayInnerStyle={{
                    color: "grey",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                  placement="bottomRight"
                  getPopupContainer={() =>
                    document.getElementById("fixed-tooltip-container")
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
            </>
          ) : currentView === "summary-status" ? (
            <RTableSelectable
              isClickable
              titleList={summaryStatusListTable}
              //data={personalDetailsData?.filter(checkStatus)}
              data={summaryStatusData}
              isResumePage
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}              
              qhjid={value}
              columnWidth={[
                50, 50, 100, 200, 100, 300, 100, 200, 200, 80, 100, 100, 100,
              ]}
            />
          ) : currentView === "skills" ? (
            <>
              <RTableSelectable
                titleList={suitablityListTable}
                //data={suitabilityData?.filter(checkStatus)}
                data={suitabilityData}
                isEditField={true}
                pullAvailableData={pullAvailableData}
                restorePreviousData={restorePreviousData}
                setFilterParameters={setFilterParameters}
                qhjid={value}
                selectable="R Only"
                columnWidth={[
                  50, 50, 100, 200, 100, 100, 100, 100, 100, 130, 200, 200, 300,
                  300, 100, 100, 150,
                ]}
              />
            </>
          ) : currentView === "resume_analysis_table" ? (
            <RTableSelectable
              isClickable={true}
              isResumePage
              automation = {true}
              linkActions = {true}
              linkCB = {matchingLinkResponseDataCallback}   
              titleList={resumeAnalysisListTable}
              data={resumeAnalysisData}
              isEditField={true}
              setCurrentView={setCurrentView}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}
              qhjid={value}
              columnWidth={[
                50, 50, 100, 200,200,100, 80, 80, 100, 100, 80, 80, 80, 100, 100, 100,
                100, 100, 100, 200,
              ]}
              colorData = {colorData}
              viewname={"JDMatchingAutomation"}
            />
          ) : currentView === "sourcing" ? (
            <RTableSelectable
              titleList={sourcingListTable}
              data={sourcingData}
              isEditField={false}
              automation
              setCurrentView={setCurrentView}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}
              qhjid={value}
              columnWidth={[50, 50, 100, 200, 300, 100, 100, 100, 60, 100, 200]}
            />
          ) : currentView === "profile" ? (
            <>
              <Button
                className="jd-summary-back-btn"
                onClick={() => {
                  navigate(`/jds/${value}`);
                  setCurrentView("summary");
                }}
              >
                <ArrowLeftOutlined />
              </Button>
              <Outlet />
            </>
          ) : (
            <>
              <RTableSelectable
                isClickable={true}
                isResumePage
                automation
                titleList={summaryListTable}
                data={summaryDataNew}
                isEditField={false}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                qhjid={value}
                selectable="C Only"
                columnWidth={[
                  50, 50, 100, 200, 200, 100, 100, 100, 100, 80, 80, 80, 80, 80,
                  80, 100, 100, 100,
                ]}
                colorData = {colorData}
                viewname={"JDMatchingAutomation"}            
              />
            </>
          )}
          {currentView !== "profile" && (
            <Pagination
              style={{
                marginTop: "4px",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
                marginBottom: "10px",
              }}
              current={currentPage}
              pageSize={pageSize}
              total={totalResumesAutoMatching}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />
            )}
                </div>
            ) : (
                <>
                  <RTableSelectable
                    isClickable={true}
                    isResumePage
                    titleList={null}
                    data={null}
                    isEditField={true}
                    setCurrentView={handleCurrentViewProfile}
                    resumeProfileHandler={handleResumeProfile}
                    filterParameters={filterApiParameters}
                    setFilterParameters={setFilterParameters}
                    setImportRefreshFlag={setImportRefreshFlag}
                    qhjid={value}
                    columnWidth={[
                      50, 50, 100, 200, 300, 100, 100, 80, 80, 80, 80, 80, 80, 200,
                      200, 100, 100, 100,
                    ]}
                  />
                  <Empty style={{ margin: "60px" }} >
                      <h4>Upload Resumes Now</h4>
                  </Empty>                  
                </>              
            )}

            <CandidateAddModal />
         
        </div>
    );
}
